export default defineNuxtRouteMiddleware((to) => {
    if (process.server) return;
  
    const referral = to.query.referal;
    if (!referral) return;
  
    // Save referral in a cookie for long-term storage
    const referralCookie = useCookie('referral', {
      maxAge: 60 * 60 * 24 * 1, // 1 day
      sameSite: 'lax',
    });
  
    referralCookie.value = String(referral);
  
    // Remove referral from query
    const { referal: _remove, ...restQueries } = to.query;
  
    // Redirect register → landing
    if (to.path.includes('register')) {
      return navigateTo('/', { replace: true });
    }
  
    // Clean URL normally
    return navigateTo(
      { path: to.path, query: restQueries },
      { replace: true }
    );
  });
  